import { get } from '@/backend/api'
import { errorMessages, isErrorResponse, parseError } from '@/backend/error'
import type { ApiResult, SSOPayload } from './types'

export const loadSSOConfig = async (teamId: number): Promise<ApiResult<SSOPayload>> => {
  try {
    const response = await get<SSOPayload>(`/teams/${teamId}/sso/saml`)
    return { ok: true, data: response.data }
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }

    return { ...parseError(error, errorMessages.LOAD_SSO_CONFIG), ok: false }
  }
}
